import {
  IBankData,
  IBankPaymentInstructionData,
  IBankPaymentInstructionPropertyData
} from '@/models';
import { IBankService } from './bank.types';
import { AxiosInstance } from 'axios';
import { axios } from '@/plugins/axios';

export class BankService implements IBankService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/banks/';
  }

  fetchBanks(): Promise<IBankData[]> {
    return this.axios
      .get<IBankData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchBank(id: number): Promise<IBankData> {
    return this.axios
      .get<IBankData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createBank(data: IBankData): Promise<IBankData> {
    return this.axios
      .post<IBankData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateBank(data: IBankData): Promise<IBankData> {
    return this.axios
      .patch<IBankData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteBank(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }

  //BankPaymentInstruction
  fetchBankPaymentInstructions(
    bankId?: number
  ): Promise<IBankPaymentInstructionData[]> {
    return this.axios
      .get<IBankPaymentInstructionData[]>(`${this.endpoint}instructions/`, {
        params: { bank__id: bankId }
      })
      .then(({ data }) => data);
  }

  fetchBankPaymentInstruction(
    id: number
  ): Promise<IBankPaymentInstructionData> {
    return this.axios
      .get<IBankPaymentInstructionData>(`${this.endpoint}instructions/${id}/`)
      .then(({ data }) => data);
  }

  createBankPaymentInstruction(
    data: IBankPaymentInstructionData
  ): Promise<IBankPaymentInstructionData> {
    return this.axios
      .post<IBankPaymentInstructionData>(`${this.endpoint}instructions/`, data)
      .then(({ data }) => data);
  }

  updateBankPaymentInstruction(
    data: IBankPaymentInstructionData
  ): Promise<IBankPaymentInstructionData> {
    return this.axios
      .patch<IBankPaymentInstructionData>(
        `${this.endpoint}instructions/${data.id}/`,
        data
      )
      .then(({ data }) => data);
  }

  deleteBankPaymentInstruction(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}instructions/${id}/`);
  }

  //BankPaymentInstructionProperty
  fetchBankPaymentInstructionProperties(
    instructionId: number
  ): Promise<IBankPaymentInstructionPropertyData[]> {
    return this.axios
      .get<IBankPaymentInstructionPropertyData[]>(
        `${this.endpoint}instructions/${instructionId}/properties/`
      )
      .then(({ data }) => data);
  }

  fetchBankPaymentInstructionProperty(
    instructionId: number,
    id: number
  ): Promise<IBankPaymentInstructionPropertyData> {
    return this.axios
      .get<IBankPaymentInstructionPropertyData>(
        `${this.endpoint}instructions/${instructionId}/properties/${id}/`
      )
      .then(({ data }) => data);
  }

  createBankPaymentInstructionProperty(
    instructionId: number,
    data: IBankPaymentInstructionPropertyData
  ): Promise<IBankPaymentInstructionPropertyData> {
    return this.axios
      .post<IBankPaymentInstructionPropertyData>(
        `${this.endpoint}instructions/${instructionId}/properties/`,
        data
      )
      .then(({ data }) => data);
  }

  updateBankPaymentInstructionProperty(
    instructionId: number,
    data: IBankPaymentInstructionPropertyData
  ): Promise<IBankPaymentInstructionPropertyData> {
    return this.axios
      .patch<IBankPaymentInstructionPropertyData>(
        `${this.endpoint}instructions/${instructionId}/properties/${data.id}/`,
        data
      )
      .then(({ data }) => data);
  }

  deleteBankPaymentInstructionProperty(
    instructionId: number,
    id: number
  ): Promise<any> {
    return this.axios.delete(
      `${this.endpoint}instructions/${instructionId}/properties/${id}/`
    );
  }
}

const bankService = new BankService(axios);
export default bankService;
